/* tslint:disable */
/* eslint-disable */
/**
 * Melco Rest Services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    MelcoModelsError,
    MelcoModelsErrorFromJSON,
    MelcoModelsErrorToJSON,
    MelcoModelsGenericList1MelcoModelsHoopListItem,
    MelcoModelsGenericList1MelcoModelsHoopListItemFromJSON,
    MelcoModelsGenericList1MelcoModelsHoopListItemToJSON,
    MelcoModelsGenericList1MelcoModelsSupplier,
    MelcoModelsGenericList1MelcoModelsSupplierFromJSON,
    MelcoModelsGenericList1MelcoModelsSupplierToJSON,
    MelcoModelsGenericList1MelcoModelsSupplierProduct,
    MelcoModelsGenericList1MelcoModelsSupplierProductFromJSON,
    MelcoModelsGenericList1MelcoModelsSupplierProductToJSON,
    MelcoModelsGenericList1MelcoModelsThread,
    MelcoModelsGenericList1MelcoModelsThreadFromJSON,
    MelcoModelsGenericList1MelcoModelsThreadToJSON,
    MelcoModelsSupplier,
    MelcoModelsSupplierFromJSON,
    MelcoModelsSupplierToJSON,
    MelcoModelsSupplierProduct,
    MelcoModelsSupplierProductFromJSON,
    MelcoModelsSupplierProductToJSON,
} from '../models';

export interface UserContentsApiAccountHoopSearchRequest {
    offset?: number;
    limit?: number;
    sortBy?: string;
    publishState?: string;
    searchText?: string;
    name?: string;
    productList?: string;
    machineList?: string;
    categoryList?: string;
    version?: string;
}

export interface UserContentsApiThreadSupplierGetRequest {
    id: string;
    publishState?: string;
}

export interface UserContentsApiThreadSupplierProductsGetRequest {
    id: string;
    publishState?: string;
}

export interface UserContentsApiThreadSupplierProductsSearchRequest {
    offset?: number;
    limit?: number;
    sortBy?: string;
    searchText?: string;
    name?: string;
    supplierId?: string;
    supplierName?: string;
    publishState?: string;
    supplierType?: string;
}

export interface UserContentsApiThreadSupplierSearchRequest {
    offset?: number;
    limit?: number;
    sortBy?: string;
    searchText?: string;
    name?: string;
    publishState?: string;
}

export interface UserContentsApiThreadsSearchRequest {
    offset?: number;
    limit?: number;
    sortBy?: string;
    publishState?: string;
    searchText?: string;
    searchTextFields?: string;
    name?: string;
    code?: string;
    argb?: string;
    supplierId?: string;
    productId?: string;
}

/**
 * 
 */
export class UserContentsApi extends runtime.BaseAPI {

    /**
     * return list of hoops
     * search hoops
     */
    async accountHoopSearchRaw(requestParameters: UserContentsApiAccountHoopSearchRequest): Promise<runtime.ApiResponse<MelcoModelsGenericList1MelcoModelsHoopListItem>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.sortBy !== undefined) {
            queryParameters['sort_by'] = requestParameters.sortBy;
        }

        if (requestParameters.publishState !== undefined) {
            queryParameters['publish_state'] = requestParameters.publishState;
        }

        if (requestParameters.searchText !== undefined) {
            queryParameters['search_text'] = requestParameters.searchText;
        }

        if (requestParameters.name !== undefined) {
            queryParameters['name'] = requestParameters.name;
        }

        if (requestParameters.productList !== undefined) {
            queryParameters['product_list'] = requestParameters.productList;
        }

        if (requestParameters.machineList !== undefined) {
            queryParameters['machine_list'] = requestParameters.machineList;
        }

        if (requestParameters.categoryList !== undefined) {
            queryParameters['category_list'] = requestParameters.categoryList;
        }

        if (requestParameters.version !== undefined) {
            queryParameters['version'] = requestParameters.version;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/hoops`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => MelcoModelsGenericList1MelcoModelsHoopListItemFromJSON(jsonValue));
    }

    /**
     * return list of hoops
     * search hoops
     */
    async accountHoopSearch(requestParameters: UserContentsApiAccountHoopSearchRequest): Promise<MelcoModelsGenericList1MelcoModelsHoopListItem> {
        const response = await this.accountHoopSearchRaw(requestParameters);
        return await response.value();
    }

    /**
     * get thread supplier
     * get thread supplier by Id
     */
    async threadSupplierGetRaw(requestParameters: UserContentsApiThreadSupplierGetRequest): Promise<runtime.ApiResponse<MelcoModelsSupplier>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling threadSupplierGet.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.publishState !== undefined) {
            queryParameters['publish_state'] = requestParameters.publishState;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/threads/suppliers/{Id}`.replace(`{${"Id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => MelcoModelsSupplierFromJSON(jsonValue));
    }

    /**
     * get thread supplier
     * get thread supplier by Id
     */
    async threadSupplierGet(requestParameters: UserContentsApiThreadSupplierGetRequest): Promise<MelcoModelsSupplier> {
        const response = await this.threadSupplierGetRaw(requestParameters);
        return await response.value();
    }

    /**
     * get thread product
     * get thread product by id
     */
    async threadSupplierProductsGetRaw(requestParameters: UserContentsApiThreadSupplierProductsGetRequest): Promise<runtime.ApiResponse<MelcoModelsSupplierProduct>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling threadSupplierProductsGet.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.publishState !== undefined) {
            queryParameters['publish_state'] = requestParameters.publishState;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/threads/suppliers/products/{Id}`.replace(`{${"Id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => MelcoModelsSupplierProductFromJSON(jsonValue));
    }

    /**
     * get thread product
     * get thread product by id
     */
    async threadSupplierProductsGet(requestParameters: UserContentsApiThreadSupplierProductsGetRequest): Promise<MelcoModelsSupplierProduct> {
        const response = await this.threadSupplierProductsGetRaw(requestParameters);
        return await response.value();
    }

    /**
     * list of supported products
     * search thread supplier products
     */
    async threadSupplierProductsSearchRaw(requestParameters: UserContentsApiThreadSupplierProductsSearchRequest): Promise<runtime.ApiResponse<MelcoModelsGenericList1MelcoModelsSupplierProduct>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.sortBy !== undefined) {
            queryParameters['sort_by'] = requestParameters.sortBy;
        }

        if (requestParameters.searchText !== undefined) {
            queryParameters['search_text'] = requestParameters.searchText;
        }

        if (requestParameters.name !== undefined) {
            queryParameters['name'] = requestParameters.name;
        }

        if (requestParameters.supplierId !== undefined) {
            queryParameters['supplier_id'] = requestParameters.supplierId;
        }

        if (requestParameters.supplierName !== undefined) {
            queryParameters['supplier_name'] = requestParameters.supplierName;
        }

        if (requestParameters.publishState !== undefined) {
            queryParameters['publish_state'] = requestParameters.publishState;
        }

        if (requestParameters.supplierType !== undefined) {
            queryParameters['supplier_type'] = requestParameters.supplierType;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/threads/suppliers/products`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => MelcoModelsGenericList1MelcoModelsSupplierProductFromJSON(jsonValue));
    }

    /**
     * list of supported products
     * search thread supplier products
     */
    async threadSupplierProductsSearch(requestParameters: UserContentsApiThreadSupplierProductsSearchRequest): Promise<MelcoModelsGenericList1MelcoModelsSupplierProduct> {
        const response = await this.threadSupplierProductsSearchRaw(requestParameters);
        return await response.value();
    }

    /**
     * list of thread supplier
     * search thread supplier list
     */
    async threadSupplierSearchRaw(requestParameters: UserContentsApiThreadSupplierSearchRequest): Promise<runtime.ApiResponse<MelcoModelsGenericList1MelcoModelsSupplier>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.sortBy !== undefined) {
            queryParameters['sort_by'] = requestParameters.sortBy;
        }

        if (requestParameters.searchText !== undefined) {
            queryParameters['search_text'] = requestParameters.searchText;
        }

        if (requestParameters.name !== undefined) {
            queryParameters['name'] = requestParameters.name;
        }

        if (requestParameters.publishState !== undefined) {
            queryParameters['publish_state'] = requestParameters.publishState;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/threads/suppliers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => MelcoModelsGenericList1MelcoModelsSupplierFromJSON(jsonValue));
    }

    /**
     * list of thread supplier
     * search thread supplier list
     */
    async threadSupplierSearch(requestParameters: UserContentsApiThreadSupplierSearchRequest): Promise<MelcoModelsGenericList1MelcoModelsSupplier> {
        const response = await this.threadSupplierSearchRaw(requestParameters);
        return await response.value();
    }

    /**
     * retrun list of threads
     * search threads
     */
    async threadsSearchRaw(requestParameters: UserContentsApiThreadsSearchRequest): Promise<runtime.ApiResponse<MelcoModelsGenericList1MelcoModelsThread>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.sortBy !== undefined) {
            queryParameters['sort_by'] = requestParameters.sortBy;
        }

        if (requestParameters.publishState !== undefined) {
            queryParameters['publish_state'] = requestParameters.publishState;
        }

        if (requestParameters.searchText !== undefined) {
            queryParameters['search_text'] = requestParameters.searchText;
        }

        if (requestParameters.searchTextFields !== undefined) {
            queryParameters['search_text_fields'] = requestParameters.searchTextFields;
        }

        if (requestParameters.name !== undefined) {
            queryParameters['name'] = requestParameters.name;
        }

        if (requestParameters.code !== undefined) {
            queryParameters['code'] = requestParameters.code;
        }

        if (requestParameters.argb !== undefined) {
            queryParameters['argb'] = requestParameters.argb;
        }

        if (requestParameters.supplierId !== undefined) {
            queryParameters['supplier_id'] = requestParameters.supplierId;
        }

        if (requestParameters.productId !== undefined) {
            queryParameters['product_id'] = requestParameters.productId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/threads`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => MelcoModelsGenericList1MelcoModelsThreadFromJSON(jsonValue));
    }

    /**
     * retrun list of threads
     * search threads
     */
    async threadsSearch(requestParameters: UserContentsApiThreadsSearchRequest): Promise<MelcoModelsGenericList1MelcoModelsThread> {
        const response = await this.threadsSearchRaw(requestParameters);
        return await response.value();
    }

}
